import { Button } from "@/components/ui/button"
import { Navigation } from "@/components/Navigation"
import { Link } from "react-router-dom"
import { MessageSquare, Zap, Shield } from "lucide-react"

const features = [
  {
    name: "Advanced AI Chat",
    description: "Engage with advanced AI models for human-like conversations",
    icon: MessageSquare,
  },
  {
    name: "Lightning Fast",
    description: "Get instant responses powered by cutting-edge technology",
    icon: Zap,
  },
  {
    name: "Secure & Private",
    description: "Your conversations are encrypted and never shared",
    icon: Shield,
  }
]

const Index = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navigation />
      
      {/* Hero Section */}
      <div className="flex-grow flex flex-col items-center justify-center px-4 sm:px-6 lg:px-8 py-12 bg-gradient-to-b from-white to-purple-50">
        <div className="text-center max-w-3xl mx-auto">
          <h1 className="text-4xl sm:text-6xl font-bold text-gray-900 mb-6">
            Experience AI Chat
          </h1>
          <p className="text-xl text-gray-600 mb-8">
            Start meaningful conversations with AgentZero, our advanced AI assistant.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/signup">
              <Button size="lg" className="w-full sm:w-auto bg-primary hover:bg-primary/90">
                Get Started Free
              </Button>
            </Link>
            <Link to="/login">
              <Button size="lg" variant="outline" className="w-full sm:w-auto">
                Login
              </Button>
            </Link>
          </div>
        </div>
      </div>

      {/* Features Section */}
      <div className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900">
              Why Choose Us?
            </h2>
            <p className="mt-4 text-lg text-gray-600">
              Simple, powerful, and secure chat experience
            </p>
          </div>

          <div className="grid grid-cols-1 gap-8 sm:grid-cols-3">
            {features.map((feature) => (
              <div 
                key={feature.name} 
                className="relative p-6 bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow"
              >
                <div className="flex items-center justify-center h-12 w-12 rounded-md bg-primary text-white mb-4">
                  <feature.icon className="h-6 w-6" />
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">
                  {feature.name}
                </h3>
                <p className="text-gray-600">
                  {feature.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Index